<template>
  <ul class="el-upload-list el-upload-list--text">
    <li class="el-upload-list__item is-success" v-for="(file, index) of fileList" :key="index">
      <a class="el-upload-list__item-name" :href="file.url || file.fileUrl" target="_blank">
        <i class="el-icon-document" />
        {{ file.name || file.fileName }}
      </a>
    </li>
  </ul>
</template>
<script>

export default {
  name: 'ShowFileList',
  props: {
    fileList: {
      type: Array,
      default: () => []
    }
  }
}
</script>
